import { useEffect, useState, useRef } from "react";

import { Sparkles, FileText, Table, CheckCircle2, Loader2, ActivityIcon, Loader } from "lucide-react";
import { motion } from "motion/react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DialogHeader } from "components/ui/dialog";
import { RichEditor } from "./richEditor";
import { DocumentLoader } from "./documentLoader";

interface ProcessingModalProps {
  open: boolean;
  currentStage:any;
  extractedHTML?:any
}

interface StreamMessage {
  type: "status" | "content" | "table";
  content: any;
  icon?: "file" | "table" | "check" | "sparkles";
}

export default function ProcessingModal({
  open,
  currentStage,extractedHTML
}: ProcessingModalProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [currentStage]);

  return (
    <Dialog disableEscapeKeyDown open={open} className="tailwind-prefix contract-flow-dialog">
      <DialogContent className="contract-flow-dialog max-w-3xl min-w-[600px] p-0 max-h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            >
              <Sparkles className="size-5 text-purple-500" />
            </motion.div>
            AI Processing Your PDF
          </DialogTitle>
        </DialogHeader>

        {/* 🔄 Stage animation */}
        <DocumentLoader extractedHTML={extractedHTML} stage={currentStage} />

        {/* 📄 LIVE EXTRACTION PREVIEW */}
        {currentStage === "streaming" && (
          <div
            ref={scrollRef}
            className="flex-1 overflow-auto border-t p-4 bg-muted/30"
          >
            <div className="text-xs text-muted-foreground mb-2 flex items-center gap-2">
              <Loader className="size-4 animate-spin" />
              Extracting content…
            </div>
            

           
          </div>
        )}

        {/* ✅ Complete */}
        {currentStage === "complete" && (
          <div className="p-4 border-t flex items-center gap-2 text-green-600">
            <CheckCircle2 className="size-5" />
            Extraction completed successfully
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
